import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import format from "date-fns/format";
import { fetchUser, resetUser } from "../../actions/authAction";

import {
  Container,
  Segment,
  Button,
  //Header,
  Confirm,
} from "semantic-ui-react";

class UserDetail extends Component {
  state = {
    id: "",
    open: false,
    result: "show the modal to capture a result",
  };

  componentDidMount() {
    const { id } = this.props.match.params;
    this.props.fetchUser(id);
  }

  componentWillUnmount() {
    this.props.resetUser();
  }
  render() {
    const {
      userId,
      uphone1,
      uphone2,
      uwhatsapp,
      uname,
      uemail,
      companyName,
      city,
      _id,
      userType,
      userSubscriptionStartOn,
      userSubscriptionExpireOn,
      //createdAt,
      cashbookcashCreate,
      cashbookcashRead,
      cashbookcashUpdate,
      cashbookcashDelete,
      cashbookbankCreate,
      cashbookbankRead,
      cashbookbankUpdate,
      cashbookbankDelete,
      saleCreate,
      saleRead,
      saleUpdate,
      saleDelete,
      purchaseCreate,
      purchaseRead,
      purchaseUpdate,
      purchaseDelete,
      allFinanceCreate,
      allFinanceRead,
      allFinanceUpdate,
      allFinanceDelete,
      acknowledgeReceipt,
      acknowledgePurchase,
    } =
      this.props.user !== undefined &&
      this.props.user !== null &&
      this.props.user;
    //********************
    const renderUserPermissionDetail = () => {
      if (userType !== "admin") {
        return (
          <React.Fragment>
            <div className="cashbook-H">
              <div
                style={{
                  display: "flex",
                  flex: "90%",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    fontSize: "1.3rem",
                    fontWeight: "bold",
                    padding: "5px",
                  }}
                >
                  PERMISSIONS TO USER
                </div>
              </div>

              {/*<div
style={{display: 'flex',flex: '10%',justifyContent: 'center',alignItems: 'center',}}
onClick={this.handleSearchSingleAccountFinance}>
    <span className='icon-button border1' > <Icon name='search' />Search</span >
  </div>*/}
            </div>
            {/**/}
            <br />

            <div>
              {/*  */}
              <div>
                <div className="head-user">CashBookCash</div>
                <div className="display-user">
                  <div>
                    <div className="heading-user">Create</div>
                    <div className="dis-user">{cashbookcashCreate}</div>
                  </div>

                  <div>
                    <div className="heading-user">Read</div>
                    <div className="dis-user">{cashbookcashRead}</div>
                  </div>

                  <div>
                    <div className="heading-user">Update</div>
                    <div className="dis-user">{cashbookcashUpdate}</div>
                  </div>

                  <div>
                    <div className="heading-user">Delete</div>
                    <div className="dis-user">{cashbookcashDelete}</div>
                  </div>
                </div>
              </div>
              {/*  */}
              <div>
                <div className="head-user">CashBookBank</div>
                <div className="display-user">
                  <div>
                    <div className="heading-user">Create</div>
                    <div className="dis-user">{cashbookbankCreate}</div>
                  </div>

                  <div>
                    <div className="heading-user">Read</div>
                    <div className="dis-user">{cashbookbankRead}</div>
                  </div>

                  <div>
                    <div className="heading-user">Update</div>
                    <div className="dis-user">{cashbookbankUpdate}</div>
                  </div>

                  <div>
                    <div className="heading-user">Delete</div>
                    <div className="dis-user">{cashbookbankDelete}</div>
                  </div>
                </div>
              </div>
              {/*  */}
              <div>
                <div className="head-user">PurchaseBook</div>
                <div className="display-user">
                  <div>
                    <div className="heading-user">Create</div>
                    <div className="dis-user">{purchaseCreate}</div>
                  </div>

                  <div>
                    <div className="heading-user">Read</div>
                    <div className="dis-user">{purchaseRead}</div>
                  </div>

                  <div>
                    <div className="heading-user">Update</div>
                    <div className="dis-user">{purchaseUpdate}</div>
                  </div>

                  <div>
                    <div className="heading-user">Delete</div>
                    <div className="dis-user">{purchaseDelete}</div>
                  </div>
                </div>
              </div>
              {/*  */}
              <div>
                <div className="head-user">SaleBook</div>
                <div className="display-user">
                  <div>
                    <div className="heading-user">Create</div>
                    <div className="dis-user">{saleCreate}</div>
                  </div>

                  <div>
                    <div className="heading-user">Read</div>
                    <div className="dis-user">{saleRead}</div>
                  </div>

                  <div>
                    <div className="heading-user">Update</div>
                    <div className="dis-user">{saleUpdate}</div>
                  </div>

                  <div>
                    <div className="heading-user">Delete</div>
                    <div className="dis-user">{saleDelete}</div>
                  </div>
                </div>
              </div>
              {/*  */}
              {/*  */}
              <div>
                <div className="head-user">All Finance</div>
                <div className="display-user">
                  <div>
                    <div className="heading-user">Create</div>
                    <div className="dis-user">{allFinanceCreate}</div>
                  </div>

                  <div>
                    <div className="heading-user">Read</div>
                    <div className="dis-user">{allFinanceRead}</div>
                  </div>

                  <div>
                    <div className="heading-user">Update</div>
                    <div className="dis-user">{allFinanceUpdate}</div>
                  </div>

                  <div>
                    <div className="heading-user">Delete</div>
                    <div className="dis-user">{allFinanceDelete}</div>
                  </div>
                </div>
              </div>
              {/*  */}
              <div>
                <div className="head-user">Acknowledge</div>
                <div className="display-user">
                  <div>
                    <div className="heading-user">Acknowledge Purchase</div>
                    <div className="dis-user">{acknowledgePurchase}</div>
                  </div>

                  <div>
                    <div className="heading-user">Acknowledge Receipt</div>
                    <div className="dis-user">{acknowledgeReceipt}</div>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        );
      }
    };
    //********************
    const { open } = this.state;
    if (
      this.props.userA !== null &&
      (this.props.userA.userType === "admin" ||
        this.props.userA.userType === "executive")
    ) {
      return (
        <Container text className="marginBottom">
          <Confirm
            // header={_id}
            size="mini"
            open={open}
            onCancel={this.handleCancel}
            onConfirm={() => this.handleConfirm()}
          />
          {/**/}
          <div className="cashbook-H">
            <div
              style={{ display: "flex", flex: "90%", justifyContent: "center" }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  fontSize: "1.3rem",
                  fontWeight: "bold",
                  padding: "5px",
                }}
              >
                User Detail
              </div>
            </div>

            {/*<div
style={{display: 'flex',flex: '10%',justifyContent: 'center',alignItems: 'center',}}
onClick={this.handleSearchSingleAccountFinance}>
      <span className='icon-button border1' > <Icon name='search' />Search</span >
    </div>*/}
          </div>
          {/**/}
          {/*<Segment
          textAlign="center"
          attached="top"
          inverted
          color="teal"
          style={{ border: "none" }}
        >
          <Header> User Detail</Header>
        </Segment>*/}
          <Segment attached>
            <Button.Group floated="right">
              <div>
                <Button
                  // basic
                  // inverted
                  floated="right"
                  color="teal"
                  type="button"
                  as={Link}
                  //target='_blank'
                  to={`/company/UserEdit/${_id}`}
                >
                  Edit
                </Button>
              </div>
              {/*<Button
              // basic
              inverted
              floated="right"
              color="red"
              type="button"
              onClick={() => this.show()}
            >
              Delete
            </Button>*/}
            </Button.Group>
            <br />
            <br />
            <div>
              {uname && (
                <div className="rowERP">
                  <div className="sideERP">
                    <b>User Name</b>
                  </div>
                  <div className="mainERP">
                    <b>{uname}</b>
                  </div>
                </div>
              )}
            </div>

            <div>
              {userId && (
                <div className="row">
                  <div className="side">
                    <b>User Id</b>
                  </div>
                  <div className="main">
                    <b>{userId}</b>
                  </div>
                </div>
              )}
            </div>
            <div>
              {uphone1 && (
                <div className="row">
                  <div className="side">
                    <b>User Phone1</b>
                  </div>
                  <div className="main">
                    <b>{uphone1}</b>
                  </div>
                </div>
              )}
            </div>
            <div>
              {uphone2 && (
                <div className="row">
                  <div className="side">
                    <b>User Phone2</b>
                  </div>
                  <div className="main">
                    <b>{uphone2}</b>
                  </div>
                </div>
              )}
            </div>
            <div>
              {uwhatsapp && (
                <div className="row">
                  <div className="side">
                    <b>Whatsapp Id</b>
                  </div>
                  <div className="main">
                    <b>{uwhatsapp}</b>
                  </div>
                </div>
              )}
            </div>

            <div>
              {uemail && (
                <div className="rowERP">
                  <div className="sideERP">
                    <b>User Email</b>
                  </div>
                  <div className="mainERP">
                    <b>{uemail}</b>
                  </div>
                </div>
              )}
            </div>
            <div>
              {companyName && (
                <div className="rowERP">
                  <div className="sideERP">
                    <b>Company Name</b>
                  </div>
                  <div className="mainERP">
                    <b>{companyName}</b>
                  </div>
                </div>
              )}
            </div>
            <div>
              {city && (
                <div className="rowERP">
                  <div className="sideERP">
                    <b>City</b>
                  </div>
                  <div className="mainERP">
                    <b>{city}</b>
                  </div>
                </div>
              )}
            </div>

            <div>
              {userType && (
                <div className="rowERP">
                  <div className="sideERP">
                    <b>User Type</b>
                  </div>
                  <div className="mainERP">
                    <b>{userType}</b>
                  </div>
                </div>
              )}
            </div>
            <div>
              {userSubscriptionStartOn && (
                <div className="rowERP">
                  <div className="sideERP">
                    <b>Subscription Start On</b>
                  </div>
                  <div className="mainERP">
                    <b>
                      {format(new Date(userSubscriptionStartOn), "MMM d yyyy")}
                    </b>{" "}
                  </div>
                </div>
              )}
            </div>

            <div>
              {userSubscriptionExpireOn && (
                <div className="rowERP">
                  <div className="sideERP">
                    <b>Subscription Expire On</b>
                  </div>
                  <div className="mainERP">
                    <b>
                      {format(new Date(userSubscriptionExpireOn), "MMM d yyyy")}
                    </b>{" "}
                  </div>
                </div>
              )}
            </div>

            {/* </Segment>
        <Segment> */}
            {/*<Segment
          textAlign="center"
          attached="top"
          inverted
          color="teal"
          style={{ border: "none" }}
        >
          <Header as="h3" color="white" content=" PERMISSIONS TO USER " />
        </Segment>*/}
            {/**/}
            {renderUserPermissionDetail()}
            {/* end  display none for desktop */}
          </Segment>
        </Container>
      );
    }
    return (
      <Container text>
        <Segment>
          <div style={{ color: "red", textAlign: "center" }}>
            <h2>You Are Not Authorised To View User Details </h2>
          </div>
        </Segment>
      </Container>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  return {
    user: auth.userD,
    userA: auth.userA,
  };
};

export default connect(mapStateToProps, { fetchUser, resetUser })(UserDetail);
